import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Loading from '../../../../common/Loading';

import ItemButton from './ItemButton';
import { ItemOptions } from '../../../../../config/constants';

import './categoryPickerHeader.css';

const CategoryPicker = ({ nextHandler, isWriting }) => {
  return (
    <div style={{ margin: '0rem 0' }}>
      <div className="categoryPickerHeaderParent">
        <div className="title categoryPickerHeader">Select Collectible Type</div>
      </div>
      <div className="has-text-centered section" style={{ padding: '1rem 0rem' }}>
        <Field
          name="category"
          options={ItemOptions}
          isWriting={isWriting}
          component={ItemButton}
          handler={(e, category) => {
            nextHandler(2, category);
          }}
        />
        {isWriting ? <Loading simple /> : ''}
      </div>
    </div>
  );
};

CategoryPicker.propTypes = {
  nextHandler: PropTypes.func.isRequired,
  isWriting: PropTypes.bool.isRequired,
};

export default CategoryPicker;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/addForms/CategoryPicker.jsx